export const GETTING_TEMPLATES = 'LOADING_TEMPLATES_IN_SMALL_TEMPLATES_LIST';
export const POPULATE_REDUCER = 'POPULATE_SMALL_TEMPLATE_LIST';
export const CALLING_API = 'ASYNC_ACTION_STARTING_IN_SMALL_TEMPLATE_LIST';
export const CLEAR_STORE = 'CLEAR_SMALL_TEMPLATE_LIST_STORE';



// WEBPACK FOOTER //
// ./src/app/stores/contracting/small-template-list/small-template-list-constants.js